import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { startOfWeek, endOfWeek } from "date-fns";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";

import AssignmentIcon from "@mui/icons-material/Assignment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";

import { getFormatDate } from "components/atoms/dateTime/GetFormattedDate";
import PageContainer from "components/templates/PageContainer";
import InfoTooltip from "components/atoms/info/InfoTooltip";
import SelectDivisionDiscipline from "components/atoms/select/SelectDivisionDiscipline";
import SelectDiscipline from "components/atoms/select/SelectDiscipline";
import SelectUnit from "components/atoms/select/SelectUnit";
import SelectActivityType from "components/atoms/select/SelectActivityType";
import ButtonDatePicker from "components/atoms/dateTime/ButtonDatePicker";
import ReportWeekReservationTable from "components/molecules/table/ReportWeekReservationTable";

const ReportWeekReservation = () => {
  const [unit, setUnit] = useState(null);
  const [division, setDivision] = useState(null);
  const [discipline, setDiscipline] = useState(null);
  const [activityType, setActivityType] = useState(null);
  const [dateReservation, setDateReservation] = useState(new Date());

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const getWeekText = () => {
    const dateSunday = startOfWeek(dateReservation);
    const dateSaturday = endOfWeek(dateReservation);
    const dateWeek = `Semana: ${getFormatDate(dateSunday)} - ${getFormatDate(dateSaturday)}`;
    return dateWeek;
  };

  const disciplineCallback = (childData) => {
    setDiscipline(childData);
  };

  const divisionCallback = (childData) => {
    disciplineCallback(null);
    setDivision(childData);
  };

  const unitCallback = (childData) => {
    disciplineCallback(null);
    divisionCallback(null);
    setUnit(childData);
  };

  const activityTypeCallback = (childData) => {
    disciplineCallback(null);
    divisionCallback(null);
    unitCallback(null);
    setActivityType(childData);
  };

  const handleChangeDateReservation = (newValue) => {
    setDateReservation(newValue);
  };

  const handleClean = (event) => {
    disciplineCallback(null);
    divisionCallback(null);
    unitCallback(null);
    activityTypeCallback(null);
    setDateReservation(new Date());
  };

  return (
    <PageContainer
      maxWidth="lg"
      title={"Programação Semanal"}
      icon={<AssignmentIcon />}
    >
      <Box id="ControlButtons" sx={{ mt: 2 }}>
        <InfoTooltip placement="top-start" title="Voltar">
          <IconButton onClick={handleBack}>
            <ArrowBackIcon />
          </IconButton>
        </InfoTooltip>
        <InfoTooltip title="Reiniciar filtros" placement="top">
          <IconButton variant="contained" onClick={handleClean}>
            <RefreshIcon />
          </IconButton>
        </InfoTooltip>
      </Box>
      <Box>
        <Typography>{getWeekText()}</Typography>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={4} sm={3} md={2}>
            <ButtonDatePicker
              value={dateReservation}
              onChange={handleChangeDateReservation}
              id="dateReservation"
              label="Data das Reservas"
              name="dateReservation"
              sx={{ mt: 1 }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <SelectActivityType
              dataParentToChild={activityType}
              parentCallback={activityTypeCallback}
            />
          </Grid>
          {activityType && activityType.id === "2" && (
            <>
              <Grid item xs={12} md={4}>
                <SelectUnit
                  dataParentToChild={unit}
                  parentCallback={unitCallback}
                />
              </Grid>
              <Grid item xs={12} lg={6}>
                <SelectDivisionDiscipline
                  idUnit={unit ? unit.id : 0}
                  dataParentToChild={division}
                  parentCallback={divisionCallback}
                />
              </Grid>
              <Grid item xs={12} lg={6}>
                <SelectDiscipline
                  idDivision={division ? division.id : 0}
                  dataParentToChild={discipline}
                  parentCallback={disciplineCallback}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Box sx={{ mt: 1, textAlign: "center" }}>
          <Typography variant="h6">{getWeekText()}</Typography>
        </Box>
        <ReportWeekReservationTable
          date={dateReservation}
          idUnit={unit && unit.id}
          idDivision={division && division.id}
          idDiscipline={discipline && discipline.id}
          idActivityType={activityType && activityType.id}
        />
      </Box>
    </PageContainer>
  );
};

export default ReportWeekReservation;
